export default "/wp-content/themes/custom-theme/dist/fonts/vendor/@mdi/materialdesignicons-webfont.eot?2146c3c82b553977abc7c824eb453634";